import {
    TiArrowSortedUp,
    TiArrowSortedDown,
    TiArrowUnsorted,
} from "react-icons/ti";
import { SortDir } from "src/hooks/useSorting";

interface SortIconProps {
    column: string;
    sortKey: string | null;
    sortDir: SortDir;
}

export function SortIcon({ column, sortKey, sortDir }: SortIconProps) {
    if (sortKey !== column)
        return <TiArrowUnsorted className="sort-icon sort-icon--inactive" />;
    return sortDir === "asc" ? (
        <TiArrowSortedUp className="sort-icon sort-icon--active" />
    ) : (
        <TiArrowSortedDown className="sort-icon sort-icon--active" />
    );
}
